document.addEventListener('DOMContentLoaded', function () {
  const tabLinks = document.querySelectorAll('.b-nav-tab');
  const tabPanels = document.querySelectorAll('.b-tab');

  if (!tabLinks.length || !tabPanels.length) return;

  function activateTab(id) {
    tabLinks.forEach((link) => {
      const isActive = link.dataset.tab === id;
      link.classList.toggle('active', isActive);
      link.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    tabPanels.forEach((panel) => {
      panel.classList.toggle('active', panel.id === id);
    });
  }

  tabLinks.forEach((link) => {
    link.setAttribute('role', 'tab');
    link.setAttribute('aria-selected', link.classList.contains('active') ? 'true' : 'false');

    link.addEventListener('click', function (e) {
      e.preventDefault();
      activateTab(link.dataset.tab);
    });
  });

  tabPanels.forEach((panel) => {
    panel.setAttribute('role', 'tabpanel');
  });
});